export default __webpack_public_path__ + "static/media/Reefer Truck Trailer.1b4bebc2.png";